import { isConsultOpen } from "@/utils/consultHours";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

/** 열려 있는 동안 경계(18:00 등)를 넘는 경우를 위한 갱신 주기 */
const REFRESH_INTERVAL_MS = 30 * 1000;

/**
 * QA용 시간대 강제. `?force_time=day` 는 열림, `?force_time=night` 는 닫힘.
 * GoiDevTools 의 "시간대 강제" 토글이 붙이는 쿼리와 같은 이름이다(platform 의 TimeSplitContainer 도 읽음).
 * 이 정책은 원래 기기 시계 기준이라 시계를 바꾸면 우회되므로 환경 제한을 두지 않는다.
 * 쿼리라 페이지 이동(push)에서는 사라지니, 확인할 페이지를 쿼리와 함께 직접 연다.
 *
 * @param forceTime - router.query.force_time (string | string[] | undefined)
 */
const parseForcedOpen = (
  forceTime: string | string[] | undefined
): boolean | null => {
  if (forceTime === "day") return true;
  if (forceTime === "night") return false;
  return null;
};

/**
 * 지금 상담 전화가 가능한지.
 *
 * 첫 렌더링에서 바로 현재 시간으로 판정한다. 서버가 이 컴포넌트를 렌더링하지 않는
 * 곳(FAQ 상세는 쿼리가 채워진 뒤, 모달은 클릭 뒤)에서만 써야 하이드레이션 불일치가 없다.
 * 서버 HTML 에 들어가는 곳에서 쓰려면 같은 높이의 자리만 두고 판정 뒤에 그리도록 바꿔야 한다
 * (FAQ 상세를 SSG 로 바꿀 때 주의).
 */
export function useConsultOpen() {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(() => isConsultOpen(new Date()));
  useEffect(() => {
    const timer = setInterval(
      () => setIsOpen(isConsultOpen(new Date())),
      REFRESH_INTERVAL_MS
    );

    return () => clearInterval(timer);
  }, []);

  return parseForcedOpen(router.query.force_time) ?? isOpen;
}
